import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./i18n";

import Providers from "../src/providers";

const app = (
  <Providers>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Providers>
);

ReactDOM.render(app, document.getElementById("root"));
